import React from 'react'
import TheFormRegister from '../TheFormRegister/TheFormRegister';

export default function AddStudentAdmin() {
  return (
    <div className="p-5">

<div className="student-register p-5 my-3 register-container"> 
        <h2><i class="fa-solid ps-2 fa-user"></i>اضافة طالب جديد :</h2>
        <TheFormRegister/>
        </div> 
        </div>
  )
}
